export class Store {
  public static readonly SESSION_STORE = 'ss'
  public static readonly SESSION_EXPIRY_TIME_STORE = 'sEtS'
  public static readonly PAYMENT_INFO_STORE = 'ps'

}
